import React, {Component} from 'react';
import axios from "axios";
import {APIURL} from "../../../config/config";
import moment from "moment";

class CarClaimItemDetail extends Component {
    constructor (props) {
        super(props)
        this.state = {
            car_claim_id: '',
            repair_item_list: []
        }
        this.loadCarClaimDetail = this.loadCarClaimDetail.bind(this)
    }

    componentDidMount() {

        this.setState({
            car_claim_id: this.props.car_claim_id
        },()=>{
            this.loadCarClaimDetail()
        })
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.car_claim_id !== '' ) {
            this.setState({
                car_claim_id: nextProps.car_claim_id
            },()=>{
                this.loadCarClaimDetail()
            })
        }
    }

    loadCarClaimDetail(){

        let claim_id = this.state.car_claim_id
        axios.get(APIURL+'/car_claim_item/claim_id/'+claim_id)
            .then(res => {
                if(res.status === 200){
                    this.setState({
                        repair_item_list: res.data
                    });

                }
            })

    }

    render() {
        if(this.state.car_claim_id === '' || this.state.repair_item_list.length === 0)
            return  null

        let repair_date = ''
        let mechanic_name = ''
        let total = ''
        let repairItemList = null
        if(this.state.repair_item_list.length > 0) {
            repair_date =' วันที่ซ่อม '+moment(this.state.repair_item_list[0].repair_date).format('LL')
            // mechanic_name =' โดย '+this.state.repair_item_list[0].mechanic_name

            repairItemList = this.state.repair_item_list.map((item,index) =>{
                return (
                    <tr key={index}>
                        <td className="text-center">{index+1}</td>
                        {/*<td className="text-center">{item.qty}</td>*/}
                        <td>{item.repair_item} </td>
                        <td>{item.mechanic_name}</td>
                        <td className="text-center" >{item.amount}</td>
                        <td>&nbsp;</td>
                    </tr>
                )
            });

            total = <tr>
                    <td className="text-right"  colSpan={3}><strong>รวมเป็นเงิน</strong></td>
                    <td className="text-center" >{this.state.repair_item_list[0].total.toLocaleString()}</td>
                    <td>&nbsp;</td>
                </tr>
        }

        return (
            <div style={styles.boxDetail}>
                <strong>รายการซ่อม {repair_date} {mechanic_name}</strong>
                <hr/>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">#</th>
                        {/*<th className="text-center">จำนวน</th>*/}
                        <th>ชื่อรายการซ่อม</th>
                        <th>อู่/ศูนย์</th>
                        <th className="text-center">จำนวนเงิน(บาท)</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className={this.state.repair_item_list.length===0? '': 'hidden'} >
                        <td colSpan={4} className="text-center text-danger">
                            ไม่พบรายการซ่อม
                        </td>
                    </tr>
                    {repairItemList}
                    {total}
                    </tbody>
                </table>
            </div>
        );
    }
}

const styles = {
    boxDetail: {
        marginTop: 8,
        paddingTop: 8,
        paddingLeft: 8,
        backgroundColor: '#c9c9c9'
    },

}

export default CarClaimItemDetail;
